// extracted by mini-css-extract-plugin
export default {"root":"ES0Eng","SloppyBorderMenuButtonNSkin":"AXrsX1","sloppyBorderMenuButtonNSkin":"AXrsX1","linkElement":"ZIUrhI","wrapper":"T87pEb","label":"lGrCXv"};